/**
 * @generated SignedSource<<788e10a32cbbfbb85649a04d6c2c7b64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type defaultAuthorCardAuthor$data = {
  readonly " $fragmentSpreads": FragmentRefs<"authorAvatarAuthor" | "authorBioAuthor" | "authorNameAuthor" | "authorSocialLinksAuthor" | "entityFollowButtonBase">;
  readonly " $fragmentType": "defaultAuthorCardAuthor";
};
export type defaultAuthorCardAuthor$key = {
  readonly " $data"?: defaultAuthorCardAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"defaultAuthorCardAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "defaultAuthorCardAuthor",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorSocialLinksAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorAvatarAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorNameAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorBioAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityFollowButtonBase"
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "04c7c404537961ab1fb761d056c3325f";

export default node;
